/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropDownItem } from '../../../state/data-form.model';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'dash-gis-table-dropdown',
    templateUrl: './table-dropdown.component.html',
    styleUrls: ['./table-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TableDropdownComponent),
            multi: true,
        },
    ],
    imports: [MatSelect, MatOption],
})
export class TableDropdownComponent implements OnInit, ControlValueAccessor {
    // tslint:disable:no-input-rename
    @Input('value') _value: any;
    @Input('placeholder') _placeholder: string;
    @Input() options: DropDownItem[] = [];

    public disabled: boolean;

    constructor() {}

    ngOnInit() {}

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        if (value) {
            this.value = value;
        }
    }

    onChange: any = () => {};
    onTouched: any = () => {};

    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    get placeholder() {
        return this._placeholder;
    }
    set placeholder(val) {
        this._placeholder = val;
        this.onChange(val);
        this.onTouched();
    }
}
